/* eslint-disable no-unused-vars */

import { SaleProceeds } from 'views/ProFormaTable/types';

export enum NON_APARTMENT_UNIT_TYPE_NAME {
    GSF = 'GSF',
    RSF = 'RSF',
    RACK = 'rack',
    KW = 'kW',
    MW = 'MW'
}

export enum APARTMENT_UNIT_TYPE_NAME {
    UNIT = 'unit',
    SF = 'sf'
}

export const UnitTypeOptionsNonApartmentEstimate = [
    { value: NON_APARTMENT_UNIT_TYPE_NAME.GSF, label: NON_APARTMENT_UNIT_TYPE_NAME.GSF },
];

export const UnitTypeOptionsNonApartmentTenants = [
    { value: NON_APARTMENT_UNIT_TYPE_NAME.GSF, label: NON_APARTMENT_UNIT_TYPE_NAME.GSF },
    { value: NON_APARTMENT_UNIT_TYPE_NAME.RSF, label: NON_APARTMENT_UNIT_TYPE_NAME.RSF },
];

export const UnitTypeOptionsDataCenter = [
    { value: NON_APARTMENT_UNIT_TYPE_NAME.RACK, label: NON_APARTMENT_UNIT_TYPE_NAME.RACK },
    { value: NON_APARTMENT_UNIT_TYPE_NAME.KW, label: NON_APARTMENT_UNIT_TYPE_NAME.KW },
    { value: NON_APARTMENT_UNIT_TYPE_NAME.MW, label: NON_APARTMENT_UNIT_TYPE_NAME.MW },
];

export const UnitTypeOptionsApartment = [
    { value: APARTMENT_UNIT_TYPE_NAME.UNIT, label: APARTMENT_UNIT_TYPE_NAME.UNIT },
    { value: APARTMENT_UNIT_TYPE_NAME.SF, label: APARTMENT_UNIT_TYPE_NAME.SF.toUpperCase() },
];

export const dataKeyByUnitType: Record<string, keyof SaleProceeds> = {
    [APARTMENT_UNIT_TYPE_NAME.UNIT]: 'perUnit',
    [APARTMENT_UNIT_TYPE_NAME.SF]: 'perSf',
    [NON_APARTMENT_UNIT_TYPE_NAME.GSF]: 'perGrossSf',
    [NON_APARTMENT_UNIT_TYPE_NAME.RSF]: 'perSf',
    [NON_APARTMENT_UNIT_TYPE_NAME.RACK]: 'perRack',
    [NON_APARTMENT_UNIT_TYPE_NAME.KW]: 'perKw',
    [NON_APARTMENT_UNIT_TYPE_NAME.MW]: 'perMw',
};
